import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
*{
  box-sizing: border-box;
}
& .MuiPopover-paper {
  max-height: 300px;
}
img{
  max-width: 100%;
}
body{
  margin: auto;
  width: 100%;
}
thead{
  background-color: #F7F7F7;
}
a{
  text-decoration: none;
}
a:active{
  color: black;
}
`;

export default GlobalStyles;
